import { AppUserActionTypes, FetchAppUser } from '../actions/AppUserActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import AppUsersApi from '../api/AppUsersApi';
import { getFetchAppUserRequestStatus } from '../selectors/RequestStatusSelector';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const fetchAppUser = requestEntity(new RequestEpicDescriptor({
  apiFunction: AppUsersApi.getUser,
  initiatingActionType: AppUserActionTypes.LOAD_APP_USER,
  requestActions: FetchAppUser,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestStatusSelector: getFetchAppUserRequestStatus
}));
export default fetchAppUser;